import { classNames, formatNumber } from '@/lib/utils';

interface ResourceBarProps {
  label: string;
  current: number;
  max: number;
  fillClass: string;
  hint?: string;
  timer?: string;
}

export function ResourceBar({
  label,
  current,
  max,
  fillClass,
  hint,
  timer,
}: ResourceBarProps): JSX.Element {
  const safeMax = Math.max(1, max);
  const clamped = Math.max(0, Math.min(current, safeMax));
  const percent = (clamped / safeMax) * 100;

  return (
    <div>
      <div className="flex items-baseline justify-between mb-1">
        <span className="text-xs font-display uppercase tracking-[0.15em] text-wood-mid">
          {label}
        </span>
        <span className="font-mono text-sm text-ink">
          {formatNumber(clamped)}
          <span className="text-ink-light"> / </span>
          {formatNumber(safeMax)}
        </span>
      </div>
      <div
        className="h-3 w-full overflow-hidden rounded-full border border-wood-mid/40 bg-parchment-dark/40 shadow-inner"
        role="progressbar"
        aria-label={label}
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={safeMax}
      >
        <div
          className={classNames(
            'h-full rounded-full transition-[width] duration-700 ease-out',
            fillClass,
          )}
          style={{ width: `${percent}%` }}
        />
      </div>
      {timer && <p className="mt-1 text-[11px] text-ink-light font-mono">{timer}</p>}
      {hint && !timer && <p className="mt-1 text-[11px] text-ink-light">{hint}</p>}
    </div>
  );
}
